import React from 'react';
import { AttentionTriangleIcon, CheckCircleIcon } from '@rsos/assets/icons';
import styled, { type Theme } from '@rsos/theme/styled';

const StyledAlert = styled.div.attrs({
  'data-name': 'alert',
})<{ variant: 'error' | 'success'; theme: Theme }>`
  display: flex;
  padding: 12px 20px;
  align-items: center;
  gap: 12px;
  align-self: stretch;

  margin: 24px 0;

  color: ${({ theme }) => theme.colors.foreground};
  background-color: ${({ variant, theme }) =>
    variant === 'error' ? theme.colors.lightDanger : theme.colors.success};
  border-radius: 5px;
  box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.1);
`;

interface AlertProps {
  variant: 'error' | 'success';
  children: React.ReactNode;
}

function Alert({ variant, children }: AlertProps) {
  return (
    <StyledAlert variant={variant}>
      {variant === 'error' ? (
        <AttentionTriangleIcon width={16} />
      ) : (
        <CheckCircleIcon width={16} />
      )}
      {children}
    </StyledAlert>
  );
}

export default Alert;
